import React from "react";
import { Box } from "@mui/material";

import DynamicTable from "../../../../data/DynamicTable/dynamicTable";
import { AccountsandFinanceurl } from "../../../../config";
import { allAccountCategories } from "../../../../data/Axios/queries";
import { AccountCategoriesColumns } from "../../../../data/DynamicTable/AccountsColumns";
import AccountCategoryForm from "./form";
const base_url = AccountsandFinanceurl.uri;
const actions = {
  entity: "Account Category",
  // Category permissions are configured as sub-rights in role management.
  isSubRight: true,
  edit: {
    key: "EDIT",
    button_name: "Edit",
    Show_Button: true,
    permission: "EditPermission",
  },
  add: {
    key: "ADD",
    button_name: "Add",
    Show_Button: true,
    permission: "CreatePermission",
  },
  activateDeactivate: {
    key: "ACTIVATEDEACTIVATE",
    button_name: "Deactivate",
    Show_Button: false,
    permission: "ActivatePermission",
  },
};
function AccountCategoriesTable() {
  return (
    <Box m="2px">
      <DynamicTable
        title="Account Categories"
        subtitle="Create, view or edit account categories"
        columns={AccountCategoriesColumns}
        FormComponent={AccountCategoryForm}
        query={allAccountCategories} //{allAccountCategories}
        base_url={base_url}
        actions={actions}
      />
    </Box>
  );
}

export default AccountCategoriesTable;
